// import { get } from 'lodash'

import { get } from 'lodash'

export default function (fields = {}) {

  if (get(fields, 'activityCategory.id') === 'OTHER') {
    fields.activityCategory.id = null
  }

  return {
    setupAssessorId: fields.setupAssessorId,
    assessorTitle: fields.assessorTitle,
    assessorName: fields.assessorName,
    assessorPhone: fields.assessorPhone,
    assessorEmail: fields.assessorEmail,
    reasonForChangingAssessor: fields.reasonForChangingAssessor,
    activityCategory: get(fields, 'activityCategory')
  }
}
